import { getField } from 'vuex-map-fields';

export const getters = {
  getField,

  /**
   * returns the fields list from the selected preload filters
   * @param {Object} state
   */
  preloadFiltersColumn(state) {
    return state.preloadFilters ? state.preloadFilters.map((filter) => filter.field) : [];
  },

  /**
   * return the allowed field object selected in the preload filter.
   * This will only return the page filters field which can be applied by user.
   * @param {Object} state
   */
  allowedFilterField(state) {
    if (state.preloadFilters) {
      const selectedColumns = state.preloadFilters
        .filter((filter) => filter.isPageFilter)
        .map((filter) => filter.field);
      return selectedColumns && selectedColumns.length > 0
        ? state.distinctFields.filter((field) => selectedColumns.includes(field.Field))
        : state.distinctFields.filter((field) => !field.Field.includes('~@~'));
    }
    return state.distinctFields.filter((field) => !field.Field.includes('~@~'));
  }
};
